// import React, { useState, useEffect } from "react";
// import Slider from "react-slick";
// import { SERVER_PATH } from "../../config/env";
// import apiClient from "../../utils/api";

// export default function Sliders() {
//   const [images, setImages] = useState([]); // Ensure the default state is an array

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await apiClient.get(
//           `get/user_landingpage.php`
//         );
//         console.log("API Response:", response.data); // Debugging: Check API response

//         // Ensure the response is an array, otherwise set an empty array
//         setImages(Array.isArray(response.data) ? response.data : []);
//       } catch (error) {
//         console.error("Error fetching images:", error);
//         setImages([]); // Fallback to an empty array in case of error
//       }
//     };

//     fetchData();
//   }, []);

//   const settings = {
//     autoplay: true,
//     autoplaySpeed: 3000,
//     dots: false,
//     infinite: true,
//     speed: 2000,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//   };

//   return (
//     <Slider {...settings}>
//       {images.map((data) => (
//         <div key={data.image_id} className="mb-0 mt-5">
//           <a href={data.link} target="_blank" rel="noopener noreferrer">
//             <img
//               src={data.path.replace(/\\/g, "\\\\")}
//               alt="Sri Mangalambika Stores offers"
//               className="img-fluid slider"
//               style={{ height: "280px", width: "100%" }}
//             />
//           </a>
//         </div>
//       ))}
//     </Slider>
//   );
// }

import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { SERVER_PATH } from "../../config/env";
import apiClient from "../../utils/api";
import "./slider.css"; // Import the custom CSS here

export default function Sliders() {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiClient.get("get/user_landingpage.php");
        console.log("API Response:", response.data);
        setImages(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching images:", error);
        setImages([]);
      }
    };

    fetchData();
  }, []);

  const settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <Slider {...settings}>
      {images.map((data) => (
        <div key={data.image_id} className="slider-wrapper">
          <a href={data.link} target="_blank" rel="noopener noreferrer">
            <img
              src={data.path.replace(/\\/g, "\\\\")}
              alt="Sri Mangalambika Stores offers"
              className="img-fluid slider"
              style={{ height: "280px", width: "100%" }}
            />
          </a>
        </div>
      ))}
    </Slider>
  );
}
